export function getNextTableScrollBudgetState(prev, next) {
    if (next === null) return prev;
    if (prev === false && next === true) return prev;
    return prev === next ? prev : next;
}
